import React from 'react'
import { Row, Col, Card, Statistic } from 'antd'
import { UserOutlined } from '@ant-design/icons'

const SummaryStatistics = ({ totals }) => {
  return (
    <Row gutter={[16, 16]}>
      <Col span={6}>
        <Card>
          <Statistic title='Total Patients' value={totals.totalPatients} prefix={<UserOutlined />} />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <Statistic
            title='Total Outstanding'
            value={totals.totalOutstanding}
            precision={2}
            prefix='R'
            valueStyle={{ color: totals.totalOutstanding > 0 ? '#ff4d4f' : '#52c41a' }}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <Statistic
            title='Medical Aid Due'
            value={totals.medicalAidOutstanding}
            precision={2}
            prefix='R'
            valueStyle={{ color: '#1890ff' }}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <Statistic
            title='Patient Due'
            value={totals.patientOutstanding}
            precision={2}
            prefix='R'
            valueStyle={{ color: '#fa8c16' }}
          />
        </Card>
      </Col>
    </Row>
  )
}

export default SummaryStatistics
